__turbopack_context__.v({
  "applybtn": "BSrRma_applybtn",
  "applybtnDiv": "BSrRma_applybtnDiv",
  "firstRow": "BSrRma_firstRow",
  "firstRowText": "BSrRma_firstRowText",
  "jobBenefits": "BSrRma_jobBenefits",
  "jobDetailCard": "BSrRma_jobDetailCard",
  "jobInfoCardTop": "BSrRma_jobInfoCardTop",
  "jobResponsibilities": "BSrRma_jobResponsibilities",
  "jobSalaryCard": "BSrRma_jobSalaryCard",
  "jobSkillsCard": "BSrRma_jobSkillsCard",
  "jobSkillsCardSpan": "BSrRma_jobSkillsCardSpan",
  "jobTypeCard": "BSrRma_jobTypeCard",
});
